<template>
    <div class="w-full md:w-auto">
        <a
            class="btn btn-md is-ghost is-danger"
            @click="$modal.show('deactivate-user')"
        >
            Inaktivera
        </a>
        <adaptive-form-modal
            name="deactivate-user"
            :primary-button-text="buttonText"
            primary-button-class="is-danger"
            title="Inaktivera användare"
            :redirect-to="redirectRoute"
            method="patch"
            :action="actionRoute"
        >
            Vill du verkligen inaktivera {{ user.name }}?
            Detta innebär att hen inte kommer kunna logga in längre.
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            redirectRoute: {
                type: String,
                required: true,
            },
            actionRoute: {
                type: String,
                required: true,
            },
        },
        computed: {
            buttonText() {
                return `Inaktivera ${this.user.name}`;
            },
        },
    };
</script>
